import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en";
import sr from "./locales/sr";

const resources = {
    sr: sr,
    en: en,
};

const storedLanguage = localStorage.getItem("language") || "en";

i18n.use(initReactI18next).init({
    resources,
    lng: storedLanguage,
    interpolation: {
        escapeValue: false,
    },
});


export default i18n;
